import { rei } from "@/services/api"

class FilhosService {
  static storeFilhos (obito_id, params) {
    params.interditado = ~~params.interditado
    return rei.post(`filho-deixado`, { obito_id,  ...params }).then(res => res.data)
  }

  static updateFilho (filho_deixado_id, params) {
    params.interditado = ~~params.interditado
    return rei.put(`filho-deixado/${filho_deixado_id}`, { ...params }).then(res => res.data)
  }

  static deleteFilho (filho_deixado_id) {
    return rei.delete(`filho-deixado/${filho_deixado_id}`).then(res => res.data)
  }
}

export default FilhosService
